import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from "./helpers";
import { HttpClient } from '@angular/common/http';

import { ScriptLoaderService } from './_services/script-loader.service';
import { EnvironmentService } from 'environments/environment-service';
@Component({
	selector: 'body',
	templateUrl: './app.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false
})

export class AppComponent implements OnInit {
	title = 'app';
	globalBodyClass = 'm-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';

	constructor(private _router: Router, private _scriptLoader: ScriptLoaderService, private httpClient: HttpClient, private environmentService: EnvironmentService) {
	}

	ngOnInit() {
		// init the environment by getting to env.json which was injected with ENVs in docker entryPoint
		const config = this.environmentService.getConfig();

		this._router.events.subscribe((route) => {
			if (route instanceof NavigationStart) {
				Helpers.setLoading(true);
				Helpers.bodyClass(this.globalBodyClass);
			}
			if (route instanceof NavigationEnd) {
				Helpers.setLoading(false);
			}
		});
	}
}